import React from "react";
import "./ugraduateContent.scss";
import Text from "componets/atoms/text/text";
import "../../../styles/fontSizes.scss";
import "../../../styles/fontSizes.scss";
import palette from "styles/palette.scss";
import CurriculumInfo from "../curriculumInfo/curriculumInfo";
// type = sobreNosotros || galeria || misionVision || historia || directorio || mapaSede || direccionSede || planeacion || relacionesI || secretariaSede
const UgraduateContent = ({ data, type }) => {
  return (
    <>
      <div className="u-graduate-content__data-container">
        {(type === "perfil" || type === "mapaSede") && (
          <>
            <Text type="h" textSize={3}>
              {data.title}
            </Text>
            <br />
            <Text type="p" textSize={1}>
              {data.description}
            </Text>
          </>
        )}
        {type === "objetivos" && (
          <>
            <Text type="h" textSize={3}>
              {data.title}
            </Text>
            <br />
            {data.description.map((paragraph, index) => (
              <>
                <Text key={index} type="p" textSize={1}>
                  {paragraph}
                </Text>
                <br />
                <hr
                  style={{
                    borderWidth: "0.2em",
                    borderColor: palette.darkGreen,
                  }}
                />
              </>
            ))}
          </>
        )}
        {type === "planEstudios" && (
          <>
            <Text type="h" textSize={3}>
              {"Plan de estudios"}
            </Text>
            <br />
            <div className="u-graduate-content__data--center">
              <CurriculumInfo data={data} />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default UgraduateContent;
